import { useState } from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Card } from '@winnin/winnin_ui.components.card'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { Title } from '@winnin/winnin_ui.components.title'

import { T } from 'lib/tolgee'

import './index.scss'

function BioCard({ loading, content }) {
  const [open, setOpen] = useState(false)

  const toggle = () => {
    setOpen(oldState => !oldState)
  }

  const containerClasss = classNames('content', { open })

  return (
    <div className="bio-card title-content">
      <Title tag="h3" className="title">
        <T keyName="BioCard-headerAbout">About</T>
      </Title>
      <div onClick={toggle}>
        <Card className={containerClasss}>
          {!loading && (
            <>
              {open && <p className="bio-card-content">{content}</p>}
              {!open && <p className="one-line-bio">{content}</p>}
            </>
          )}
          {loading && <Loading />}
        </Card>
      </div>
    </div>
  )
}

export default observer(BioCard)
